import { receiveFecha, receiveFechaFormat2, sendCheck } from "../../../../../../adapters/helpers"

const AlquileresAdapters = {

    GET: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    id: item.idpedido || '',
                    numeropedido: item.numeropedido || '',
                    fechapedido: receiveFechaFormat2(receiveFecha(item.fechapedido)),
                    idpersona: item.idpersona || '',
                    idpersonaentidad: item.idpersonaentidad || '',
                    estado: item.estado || '',
                    abona: item.abona || '',
                    fechadesde: receiveFechaFormat2(receiveFecha(item.fechadesde)),
                    fechahasta: receiveFechaFormat2(receiveFecha(item.fechahasta)),
                    fechaentrega: receiveFechaFormat2(receiveFecha(item.fechaentrega)),
                    destinatarioenvio: item.destinatarioenvio || '',
                    direccionenvio: item.direccionenvio || '',
                    observacionesenvio: item.observacionesenvio || '',
                    municipioenvio: item.municipioenvio || '',
                    idpaisenvio: item.idpaisenvio || '',
                    idprovinciaenvio: item.idprovinciaenvio || '',
                    cpenvio: item.cpenvio || '',
                    titularcuenta: item.titularcuenta || '',
                    idbanco: item.idbanco || '',
                    sucursal: item.sucursal || '',
                    digitocontrol: item.digitocontrol || '',
                    cuentacorriente: item.cuentacorriente || '',
                    iban: item.iban || '',
                    observaciones: item.observaciones || '',
                    idsolicitud: item.idsolicitud || '',
                    idcondicionpago: item.idcondicionpago || '',
                    porcentajedescuento: item.porcentajedescuento || '',
                    importetotal: item.importetotal || '',
                    email: item.email || '',
                    facturado: item.facturado || '',
                    producto: item.pedidos_productos?.[0]?.producto?.producto || '',
                    nombrepersona: item.nombrepersona || '',

                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data?.data

                const items = dataTemp?.data?.map((item: any) => (this.schema(item)))

                return {
                    data: {
                        total: dataTemp?.total,
                        per_page: dataTemp?.per_page,
                        current_page: dataTemp?.current_page,
                        items
                    },
                    status: data?.status
                }
            }
        },
    },

    GET_CHECK_DISPONIBILIDAD:  {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    data: item.data,
                    error: item.error,
                    message: item.message,
                    status: item.status
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const items = this.schema(dataTemp)

                return {
                    data: items,
                    status: data?.status
                }
            }
        },

        send: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    idproducto: item.idproducto || '',
                    fechadesde: item.fechadesde || '',
                    fechahasta: item.fechahasta || '',
                    idpersona: item.idpersona || '',
                    // idpersonaentidad: item.idpersonaentidad || '',
                }

                return data
            },

            adapter: function (data: any) {

                const items = this.schema(data)

                return {
                    ...items
                }
            }
        },
    },
    
    GET_TARIFAS_CONDICIONES_PAGO:  {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    cantidaddiascobro: item.cantidaddiascobro || '',
                    condicionespagos: item.condicionespagos || {},
                    tarifas: item.tarifas || {},
                    totalimportebase: item.totalimportebase || '',
                    totalimporteiva: item.totalimporteiva || '',
                    totalimportetotal: item.totalimportetotal || '',
                    iva: item.iva || {},
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data?.data

                const items = this.schema(dataTemp)

                return {
                    data: items,
                    status: data?.status
                }
            }
        },

        send: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    idproducto: item.idproducto || '',
                    fechadesde: item.fechadesde || '',
                    fechahasta: item.fechahasta || '',
                    idpersona: item.idpersona || '',
                    // idpersonaentidad: item.idpersonaentidad || '',
                }

                return data
            },

            adapter: function (data: any) {

                const items = this.schema(data)

                return {
                    ...items
                }
            }
        },
    },

    GET_CONDICIONES_PAGO:  {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    condicionespagos: item.condicionespagos || {},
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data?.data

                const items = this.schema(dataTemp)

                return {
                    data: items,
                    status: data?.status
                }
            }
        },

        send: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    idproducto: item.idproducto || '',
                    fechadesde: item.fechadesde || '',
                    fechahasta: item.fechahasta || '',
                    idpersona: item.idpersona || '',
                    // idpersonaentidad: item.idpersonaentidad || '',
                }

                return data
            },

            adapter: function (data: any) {

                const items = this.schema(data)

                return {
                    ...items
                }
            }
        },
    },
}

const AlquilerAdapters = {

    GET: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    id: item.idpedido || '',
                    condicionpago: item.condicionpago || '',
                    cuentacorriente: item.cuentacorriente || '',
                    digitocontrol: item.digitocontrol || '',
                    email: item.email || '',
                    estado: item.estado || '',
                    facturado: item.facturado || '',
                    facturas: item.facturas || [],
                    fechadesde: receiveFecha(item.fechadesde),
                    fechaentrega: item.fechaentrega || '',
                    fechahasta: receiveFecha(item.fechahasta),
                    fechapedido: item.fechapedido || '',
                    iban: item.iban || '',
                    idbanco: item.idbanco || '',
                    idcondicionpago: item.idcondicionpago || '',
                    idpedido: item.idpedido || '',
                    idpersona: item.idpersona || '',
                    idpersonaentidad: item.idpersonaentidad || '',
                    idsolicitud: item.idsolicitud || '',
                    importetotal: item.importetotal || '',
                    nombrepersona: item.nombrepersona || '',
                    numeropedido: item.numeropedido || '',
                    observaciones: item.observaciones || '',
                    observacionesenvio: item.observacionesenvio || '',
                    porcentajedescuento: item.porcentajedescuento || '',
                    sucursal: item.sucursal || '',
                    titularcuenta: item.titularcuenta || '',
                    abona: item.idpersonaentidad ? 'E' : 'P',
                    idproducto: item.pedidos_productos?.[0]?.idproducto || '',
                    producto: item.pedidos_productos?.[0]?.producto?.producto || '',
                    idproductotarifa: item.idproductotarifa || '',
                    pedidos_productos: item.pedidos_productos || [],
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data?.data
                
                // const items = dataTemp?.data?.map((item: any) => (this.schema(item)))
                const items = this.schema(dataTemp?.[0])

                return {
                    data: {
                        ...items
                    },
                    status: data?.status
                }
            }
        },
    },

    POST: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    data: item.data,
                    message: item.message,
                    status: item.status
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const items = this.schema(dataTemp)

                return {
                    data: items,
                    status: data?.status
                }
            }
        },

        send: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    idproducto: item.idproducto || '',
                    idpersonaentidad: item.idpersonaentidad || '',
                    idpersona: item.idpersona || '',
                    idcondicionpago: item.idcondicionpago || '',
                    idproductotarifa: item.idproductotarifa || '',
                    observacionesenvio: item.observacionesenvio || '',
                    fechadesde: item.fechadesde || '',
                    fechahasta: item.fechahasta || '',
                    comunicar: sendCheck(item.comunicar),
                    facturar: sendCheck(item.facturar),
                    inputtotalimportebase: item.inputtotalimportebase || '0',
                    inputtotalimporteiva: item.inputtotalimporteiva || '0',
                    idiva: item.idiva || '',
                }

                if (!data.idpersonaentidad) delete data.idpersonaentidad

                return data
            },

            adapter: function (data: any) {

                const items = this.schema(data)

                return {
                    ...items
                }
            }
        },
    },

    PATCH: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    message: item.message,
                    status: item.status
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const items = this.schema(dataTemp)

                
                return {
                    data: items,
                    status: data?.status
                }
            }
        },

        send: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    idproducto: item.idproducto || '',
                    idproductotarifa: item.idproductotarifa || '',
                    idpersonaentidad: item.idpersonaentidad || '',
                    idpersona: item.idpersona || '',
                    idcondicionpago: item.idcondicionpago || '',
                    observacionesenvio: item.observacionesenvio || '',
                    fechadesde: item.fechadesde || '',
                    fechahasta: item.fechahasta || '',
                    comunicar: sendCheck(item.comunicar),
                    inputtotalimportebase: item.inputtotalimportebase || '0',
                    inputtotalimporteiva: item.inputtotalimporteiva || '0',
                    idiva: item.idiva || '',
                    // facturar: sendCheck(item.facturar),
                }

                // if (!data.idpersonaentidad) delete data.idpersonaentidad

                return data
            },

            adapter: function (data: any) {

                const items = this.schema(data)

                return {
                    ...items
                }
            }
        },
    },

    PATCH_CAMBIAR_ESTADO: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    message: item.message,
                    status: item.status
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const items = this.schema(dataTemp)

                return {
                    data: items,
                    status: data?.status
                }
            }
        },

        send: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    estado: item.estado || '',
                    comunicar: item.comunicar || false,
                }

                return data
            },

            adapter: function (data: any) {

                const items = this.schema(data)

                return {
                    ...items
                }
            }
        },
    },

    POST_GENERAR_FACTURA: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    data: item.data,
                    message: item.message,
                    status: item.status
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const items = this.schema(dataTemp)

                return {
                    data: items,
                    status: data?.status
                }
            }
        },

        send: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    idproducto: item.idproducto || '',
                    idpersonaentidad: item.idpersonaentidad || '',
                    idpersona: item.idpersona || '',
                    idcondicionpago: item.idcondicionpago || '',
                    idproductotarifa: item.idproductotarifa || '',
                    observacionesenvio: item.observacionesenvio || '',
                    fechadesde: item.fechadesde || '',
                    fechahasta: item.fechahasta || '',
                    comunicar: sendCheck(item.comunicar),
                    facturar: sendCheck(item.facturar),
                    idpedido: item.id || '',
                }

                if (!data.idpersonaentidad) delete data.idpersonaentidad

                return data
            },

            adapter: function (data: any) {

                const items = this.schema(data)

                return {
                    ...items
                }
            }
        },
    },
}

export {
    AlquileresAdapters,
    AlquilerAdapters,
}